import { OptionKey } from '@common-fe/common-fe';

import {
  ReportSummaryRequestBaseParams,
  ReportTableRequestBaseParams,
} from '../ReportSummary/ReportSummary.types';

export enum DelinquentClaimsReportView {
  ByEmployee = 'BY_EMPLOYEE',
  ByClaim = 'BY_CLAIM',
}

export interface DelinquentClaimsSummaryReportParams extends ReportSummaryRequestBaseParams {
  accountTypes: OptionKey[];
  planIds: OptionKey[];
  planYearPeriod: OptionKey[];
}

export interface DelinquentClaimsReportTableParams extends ReportTableRequestBaseParams {
  isSSNShowed: boolean;
  reportView: DelinquentClaimsReportView;
  accountTypes: OptionKey[];
  planIds: OptionKey[];
  planYearPeriod: OptionKey[];
  claimStatuses: OptionKey[];
}
